import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import { CartProvider } from '@/context/CartContext';
import { ChatProvider } from '@/context/ChatContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { CartDrawer } from '@/components/CartDrawer';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import Home from '@/pages/Home';
import Shop from '@/pages/Shop';
import Sets from '@/pages/Sets';
import ProductDetail from '@/pages/ProductDetail';
import Checkout from '@/pages/Checkout';
import PaymentResult from '@/pages/PaymentResult';
import Reels from '@/pages/Reels';
import Auth from '@/pages/Auth';
import AuthCallback from '@/pages/AuthCallback';
import Account from '@/pages/Account';
import Wishlist from '@/pages/Wishlist';
import FAQ from '@/pages/FAQ';
import CareCard from '@/pages/CareCard';
import Admin from '@/pages/Admin';
import { WhatsAppButton } from '@/components/WhatsAppButton';
import { CookieBanner } from '@/components/CookieBanner';

function Shell({ children, hideChrome = false }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      {!hideChrome && <Navbar />}
      <main className="flex-1">{children}</main>
      {!hideChrome && <Footer />}
      <CartDrawer />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Shell><Home /></Shell>} />
      <Route path="/shop" element={<Shell><Shop /></Shell>} />
      <Route path="/sets" element={<Shell><Sets /></Shell>} />
      <Route path="/presale" element={<Shell><Shop presale /></Shell>} />
      <Route path="/product/:id" element={<Shell><ProductDetail /></Shell>} />
      <Route path="/reels" element={<Reels />} />
      <Route path="/faq" element={<Shell><FAQ /></Shell>} />
      <Route path="/care-card" element={<CareCard />} />
      <Route path="/auth" element={<Shell><Auth /></Shell>} />
      <Route path="/checkout" element={<Shell><ProtectedRoute><Checkout /></ProtectedRoute></Shell>} />
      <Route path="/payment/success" element={<Shell><PaymentResult /></Shell>} />
      <Route path="/payment/cancel" element={<Shell><PaymentResult cancelled /></Shell>} />
      <Route path="/account" element={<Shell><ProtectedRoute><Account /></ProtectedRoute></Shell>} />
      <Route path="/wishlist" element={<Shell><ProtectedRoute><Wishlist /></ProtectedRoute></Shell>} />
      <Route path="/admin" element={<Shell><ProtectedRoute adminOnly><Admin /></ProtectedRoute></Shell>} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CartProvider>
          <ChatProvider>
            <BrowserRouter>
              <AppRouter />
              <WhatsAppButton />
              <CookieBanner />
              <Toaster position="top-center" />
            </BrowserRouter>
          </ChatProvider>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
